import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './tokens/tokens.css'
import './index.css'
import './lib/borderGlow'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
